
export default {
  name: 'OrganismLoader',
  props: {
    contentLoader: {
      required: true,
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
